export const TRACKING_GTM = 'TRACKING_GTM';
export const UNIVERSAL_ANALYTICS_SESSION_INIT_DID_FIRE_PAYLOAD_PROP = 'universalAnalyticsSessionInitDidFire';

export interface TrackingState {
    universalAnalyticsSessionInitDidFire: boolean;
}

export interface PagePayloadInterface {
    [UNIVERSAL_ANALYTICS_SESSION_INIT_DID_FIRE_PAYLOAD_PROP]: boolean;
}

export interface TrackingActionInterface {
    type: typeof TRACKING_GTM;
    payload: PagePayloadInterface;
}

export type TrackingActionTypes = TrackingActionInterface;
